/*
 * df-search.js — Buscador predictivo del df-search-modal.
 * Conecta el modal con /search/suggest.json y gestiona resultados visuales.
 */
(function () {
  'use strict';

  var RECENT_KEY = 'df_search_recents';
  var MAX_RECENT = 5;
  var DEBOUNCE_MS = 200;

  // Lo que no sale nunca en el buscador: el papel de regalo (se decide en la
  // cesta, no buscándolo) y cualquier cosa agotada.
  var HIDDEN_HANDLES = ['gift-wrap'];
  function isListable(p) {
    if (!p) return false;
    if (HIDDEN_HANDLES.indexOf(p.handle) !== -1) return false;
    return p.available !== false;
  }

  var modal, input, clearBtn, defaults, results, body;
  var productsGroup, productsList, productsCount;
  var collectionsGroup, collectionsList;
  var pagesGroup, pagesList;
  var loadingEl, emptyEl, seeAllEl, seeAllLink, totalEl;
  var recentGroup, recentChips;

  var currentTimer = null;
  var currentQuery = '';
  var lastAbort = null;

  function init() {
    modal = document.getElementById('df-search-modal');
    if (!modal) return;

    input = modal.querySelector('[data-df-search-input]');
    clearBtn = modal.querySelector('[data-df-search-clear]');
    defaults = modal.querySelector('[data-df-search-defaults]');
    results = modal.querySelector('[data-df-search-results]');
    body = modal.querySelector('[data-df-search-body]');

    productsGroup = modal.querySelector('[data-df-search-products-group]');
    productsList = modal.querySelector('[data-df-search-products]');
    productsCount = modal.querySelector('[data-df-search-products-count]');
    collectionsGroup = modal.querySelector('[data-df-search-collections-group]');
    collectionsList = modal.querySelector('[data-df-search-collections]');
    pagesGroup = modal.querySelector('[data-df-search-pages-group]');
    pagesList = modal.querySelector('[data-df-search-pages]');

    loadingEl = modal.querySelector('[data-df-search-loading]');
    emptyEl = modal.querySelector('[data-df-search-empty]');
    seeAllEl = modal.querySelector('[data-df-search-see-all]');
    seeAllLink = modal.querySelector('[data-df-search-see-all-link]');
    totalEl = modal.querySelector('[data-df-search-total]');

    recentGroup = modal.querySelector('[data-df-search-recent-group]');
    recentChips = modal.querySelector('[data-df-search-recents]');

    if (!input) return;

    renderRecents();

    // Input
    input.addEventListener('input', onInputChange);
    input.addEventListener('keydown', onKeyDown);

    // Clear button
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
        onInputChange();
      });
    }

    // Suggest chips (top + recents)
    modal.addEventListener('click', function (e) {
      var sug = e.target.closest('[data-df-search-suggest]');
      if (sug) {
        input.value = sug.getAttribute('data-df-search-suggest');
        input.focus();
        onInputChange();
      }
    });

    // Clear recents
    var clearRecent = modal.querySelector('[data-df-search-clear-recent]');
    if (clearRecent) {
      clearRecent.addEventListener('click', function () {
        localStorage.removeItem(RECENT_KEY);
        renderRecents();
      });
    }

    // Form submit (Enter → /search?q=)
    var form = modal.querySelector('[data-df-search-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        var q = input.value.trim();
        if (q) {
          saveRecent(q);
          trackSearch(q);
        }
        // Form action ya es /search, dejamos submit nativo
      });
    }

    // Reset state when modal opens (handled by dondefue.js, here we just observe)
    var mo = new MutationObserver(function () {
      if (!modal.hidden && document.activeElement !== input) {
        setTimeout(function () { input && input.focus(); }, 80);
      }
    });
    mo.observe(modal, { attributes: true, attributeFilter: ['hidden'] });
  }

  function onInputChange() {
    var q = input.value.trim();
    currentQuery = q;
    if (clearBtn) clearBtn.hidden = !q;

    if (currentTimer) clearTimeout(currentTimer);

    if (!q) {
      showDefaults();
      return;
    }

    currentTimer = setTimeout(function () { runSearch(q); }, DEBOUNCE_MS);
  }

  function showDefaults() {
    defaults.hidden = false;
    results.hidden = true;
    renderRecents();
  }

  function showResults() {
    defaults.hidden = true;
    results.hidden = false;
  }

  function showLoading() {
    showResults();
    loadingEl.hidden = false;
    productsGroup.hidden = true;
    collectionsGroup.hidden = true;
    pagesGroup.hidden = true;
    emptyEl.hidden = true;
    seeAllEl.hidden = true;
  }

  // === Spanish-friendly normalization & synonyms ===
  // Map accents → base letters
  function stripAccents(s) {
    if (!s) return '';
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  // Common Spanish synonym pairs (bidirectional)
  // If user types one, also try the other.
  var SYNONYMS = {
    'mama': ['mamá', 'madre'], 'mamá': ['mama', 'madre'], 'madre': ['mama', 'mamá'],
    'papa': ['papá', 'padre'], 'papá': ['papa', 'padre'], 'padre': ['papa', 'papá'],
    'cuadro': ['lámina', 'poster', 'lamina'], 'lamina': ['cuadro', 'lámina', 'poster'], 'lámina': ['cuadro', 'lamina', 'poster'],
    'poster': ['cuadro', 'lámina', 'lamina'], 'póster': ['cuadro', 'lámina'],
    'taza': ['mug', 'tazas', 'tazas mágicas', 'taza mágica'],
    'sudadera': ['hoodie', 'jersey'],
    'camiseta': ['tshirt', 't-shirt'],
    'pareja': ['novia', 'novio', 'esposa', 'esposo', 'love'],
    'novio': ['pareja', 'love'], 'novia': ['pareja', 'love'],
    'aniversario': ['aniversarios', 'love', 'pareja'],
    'cumpleanos': ['cumpleaños', 'cumple', 'bday'], 'cumpleaños': ['cumpleanos', 'cumple', 'bday'],
    'navidad': ['navidades', 'christmas'],
    'boda': ['bodas', 'wedding', 'casamiento'], 'bodas': ['boda', 'wedding'],
    'amigo': ['amigos', 'amigas', 'amig@'], 'amigos': ['amigo', 'amig@'],
    'nacimiento': ['bebé', 'bebe', 'recién nacido', 'baby'],
    'bebé': ['bebe', 'nacimiento', 'baby'],
    'bebe': ['bebé', 'nacimiento', 'baby'],
    'cancion': ['canción', 'songs'], 'canción': ['cancion'],
    'mapa': ['mapas', 'coordenadas', 'donde fue', 'localización', 'ciudad'],
    'foto': ['fotos', 'imagen', 'imágenes'],
    'regalo': ['regalos', 'gift', 'presente'],
    'corazon': ['corazón', 'love', 'amor'], 'corazón': ['corazon', 'love', 'amor'],
    'estelar': ['estrella', 'estrellas', 'cielo', 'mapa estelar'],
    'tio': ['tío', 'tía'], 'tia': ['tía', 'tío'],
    'abuelo': ['abuelos', 'abuela', 'yayo', 'yaya'],
    'abuela': ['abuelas', 'yaya', 'abuelo'],
    'hijo': ['hijos', 'hija', 'hijas'], 'hija': ['hijas', 'hijo'],
    'familia': ['familiar', 'familiares'],
    'personalizado': ['personalizada', 'personalizable', 'custom']
  };

  // Heuristic recovery: collection landings for common intents
  var INTENT_COLLECTIONS = [
    { match: /\b(mama|mamá|madre|día de la madre|dia de la madre|mami)\b/i, url: '/collections/para-mama', label: 'Para Mamá' },
    { match: /\b(papa|papá|padre|día del padre|dia del padre)\b/i, url: '/collections/para-papa', label: 'Para Papá' },
    { match: /\b(pareja|novia|novio|aniversario|love|amor|amantes|esposa|esposo)\b/i, url: '/collections/para-parejas', label: 'Para Pareja' },
    { match: /\b(taza|mug|tazas)\b/i, url: '/collections/tazas-magicas', label: 'Tazas mágicas' },
    { match: /\b(sudadera|camiseta|hoodie|ropa|textil|jersey)\b/i, url: '/collections/ropa-y-accesorios', label: 'Ropa y accesorios' },
    { match: /\b(cuadro|lámina|lamina|poster|mapa|estelar|coordenadas)\b/i, url: '/collections/cuadros-personalizados', label: 'Cuadros personalizados' },
    { match: /\b(familia|familiar|hijo|hija|abuelo|abuela|tio|tia)\b/i, url: '/collections/regalos-para-la-familia', label: 'Para la familia' },
    { match: /\b(nuevo|novedad|novedades|nuevos|recién|reciente)\b/i, url: '/collections/novedades-1', label: 'Novedades' }
  ];

  function buildSuggestUrl(q, limit) {
    return '/search/suggest.json' +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page' +
      '&resources[limit]=' + limit +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,body,tag' +
      '&resources[options][prefix]=last';
  }

  function fetchOnce(url, signal) {
    return fetch(url, { signal: signal, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function countResults(data) {
    var r = (data && data.resources && data.resources.results) || {};
    return (r.products || []).filter(isListable).length + (r.collections || []).length + (r.pages || []).length;
  }

  // Build alternative queries to try when exact yields nothing.
  function buildFallbackQueries(q) {
    var queries = [];
    var seen = {};
    function add(s) {
      var key = (s || '').toLowerCase().trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      queries.push(s);
    }

    // 1. Accent-stripped
    var stripped = stripAccents(q);
    if (stripped !== q) add(stripped);

    // 2. Add accents (heuristic): try synonyms of each token
    var tokens = q.toLowerCase().split(/\s+/).filter(Boolean);
    var anySyn = false;
    var synTokens = tokens.map(function (t) {
      var bare = stripAccents(t);
      var syn = SYNONYMS[t] || SYNONYMS[bare];
      if (syn && syn.length) {
        anySyn = true;
        // First synonym substitutes
        return syn[0];
      }
      return t;
    });
    if (anySyn) add(synTokens.join(' '));

    // 3. Wildcard suffix (e.g. "regal" → "regal*")
    var lastToken = tokens[tokens.length - 1];
    if (lastToken && lastToken.length >= 3 && !/\*$/.test(lastToken)) {
      var wild = tokens.slice(0, -1).concat(lastToken + '*').join(' ');
      add(wild);
    }

    // 4. Single-token searches (each word independently) — broader OR
    if (tokens.length > 1) {
      tokens.forEach(function (t) {
        if (t.length >= 3) add(t);
      });
    }

    return queries;
  }

  function detectIntents(q) {
    return INTENT_COLLECTIONS.filter(function (intent) {
      return intent.match.test(q) || intent.match.test(stripAccents(q));
    });
  }

  function runSearch(q) {
    if (lastAbort) try { lastAbort.abort(); } catch (e) {}
    lastAbort = ('AbortController' in window) ? new AbortController() : null;

    showLoading();

    var limit = Number(window.dfSearchLimit || 6);

    // Strategy: try exact first, then fallback chain.
    var queries = [q].concat(buildFallbackQueries(q));
    var attemptIdx = 0;

    function tryNext() {
      if (attemptIdx >= queries.length) {
        // All strategies exhausted → render with intents fallback
        renderResults({ resources: { results: { products: [], collections: [], pages: [] } } }, q, /*usedFallback*/ true);
        return;
      }
      var candidate = queries[attemptIdx++];
      var url = buildSuggestUrl(candidate, limit);
      fetchOnce(url, lastAbort ? lastAbort.signal : undefined)
        .then(function (data) {
          if (q !== currentQuery) return; // race condition
          if (countResults(data) > 0) {
            renderResults(data, q, attemptIdx > 1);
          } else {
            tryNext();
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          tryNext();
        });
    }
    tryNext();
  }

  function renderResults(data, q, usedFallback) {
    loadingEl.hidden = true;

    var resources = (data && data.resources && data.resources.results) || {};
    var products = (resources.products || []).filter(isListable);
    var collections = resources.collections || [];
    var pages = resources.pages || [];

    var total = products.length + collections.length + pages.length;

    // If we had to use a fallback strategy, hint to the user
    if (usedFallback && total > 0) {
      productsCount && (productsCount.innerHTML = String(products.length) + ' <span class="df-search-modal__hint">· resultados aproximados</span>');
    }

    // Products
    productsList.innerHTML = '';
    if (products.length) {
      productsGroup.hidden = false;
      productsCount.textContent = String(products.length);
      products.forEach(function (p) {
        var row = document.createElement('a');
        row.className = 'df-search-modal__product-row';
        row.setAttribute('data-df-search-result', '');
        row.href = p.url;
        var img = (p.image || p.featured_image);
        var price = (p.price || (p.variants && p.variants[0] && p.variants[0].price));
        if (typeof price === 'string') price = parseFloat(price.replace(/[^\d.,]/g, '').replace(',', '.'));
        row.innerHTML =
          (img ? '<img src="' + img + '" alt="" class="df-search-modal__product-img" loading="lazy" width="112" height="112">' : '<span class="df-search-modal__product-img-empty"></span>') +
          '<span class="df-search-modal__product-info">' +
            '<h3 class="df-search-modal__product-title">' + highlight(p.title, q) + '</h3>' +
            '<span class="df-search-modal__product-meta">' +
              (p.product_type ? '<span>' + p.product_type + '</span><span>·</span>' : '') +
              '<span class="df-search-modal__product-price">' + formatPrice(price) + '</span>' +
            '</span>' +
          '</span>' +
          '<span class="df-search-modal__product-cta">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>' +
          '</span>';
        productsList.appendChild(row);
      });
    } else {
      productsGroup.hidden = true;
    }

    // Collections
    collectionsList.innerHTML = '';
    if (collections.length) {
      collectionsGroup.hidden = false;
      collections.forEach(function (c) {
        var row = document.createElement('a');
        row.className = 'df-search-modal__row';
        row.setAttribute('data-df-search-result', '');
        row.href = c.url;
        row.innerHTML =
          '<span>' + highlight(c.title, q) + '</span>' +
          (c.products_count !== undefined ? '<span class="df-search-modal__row-meta">' + c.products_count + ' productos</span>' : '');
        collectionsList.appendChild(row);
      });
    } else {
      collectionsGroup.hidden = true;
    }

    // Pages
    pagesList.innerHTML = '';
    if (pages.length) {
      pagesGroup.hidden = false;
      pages.forEach(function (p) {
        var row = document.createElement('a');
        row.className = 'df-search-modal__row';
        row.setAttribute('data-df-search-result', '');
        row.href = p.url;
        row.innerHTML = '<span>' + highlight(p.title, q) + '</span>';
        pagesList.appendChild(row);
      });
    } else {
      pagesGroup.hidden = true;
    }

    // Empty state with smart recovery
    if (total === 0) {
      emptyEl.hidden = false;
      seeAllEl.hidden = true;

      // Show intent-based collection links + bestsellers cross-sell
      var intents = detectIntents(q);
      var rescueHtml = '';
      if (intents.length > 0) {
        rescueHtml += '<div class="df-search-modal__rescue-eyebrow">QUIZÁ BUSCAS</div>';
        rescueHtml += '<div class="df-search-modal__rescue-grid">';
        intents.slice(0, 3).forEach(function (intent) {
          rescueHtml += '<a href="' + intent.url + '" class="df-search-modal__rescue-card">' +
                          '<span>' + intent.label + '</span>' +
                          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>' +
                        '</a>';
        });
        rescueHtml += '</div>';
      }
      rescueHtml += '<div class="df-search-modal__rescue-actions">' +
        '<a href="/search?q=' + encodeURIComponent(q) + '" class="df-btn df-btn--outline-ink df-btn--sm">Ver búsqueda completa</a> ' +
        '<a href="/collections/novedades-1" class="df-btn df-btn--red df-btn--sm">Ver bestsellers</a>' +
      '</div>';
      emptyEl.innerHTML =
        '<p class="df-h df-h--32">No encontramos <em>"' + escapeHtml(q) + '"</em></p>' +
        '<p class="df-body df-body--sm">Igual lo decimos con otra palabra. Prueba estas pistas:</p>' +
        rescueHtml;
    } else {
      emptyEl.hidden = true;
      seeAllEl.hidden = false;
      if (totalEl) totalEl.textContent = String(total);
      if (seeAllLink) seeAllLink.href = '/search?q=' + encodeURIComponent(q);
    }
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  function highlight(text, q) {
    if (!text) return '';
    var safe = String(text).replace(/[&<>"']/g, function (c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
    if (!q) return safe;
    var escQ = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('(' + escQ + ')', 'ig');
    return safe.replace(re, '<mark>$1</mark>');
  }

  function formatPrice(p) {
    if (typeof p !== 'number' || isNaN(p)) return '';
    return p.toFixed(2).replace('.', ',') + ' €';
  }

  // === RECENTS ===
  function getRecents() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveRecent(q) {
    if (!q) return;
    var list = getRecents();
    list = list.filter(function (x) { return x !== q; });
    list.unshift(q);
    list = list.slice(0, MAX_RECENT);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function renderRecents() {
    if (!recentGroup || !recentChips) return;
    var list = getRecents();
    if (!list.length) {
      recentGroup.hidden = true;
      return;
    }
    recentGroup.hidden = false;
    recentChips.innerHTML = '';
    list.forEach(function (q) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'df-chip df-search-modal__chip';
      b.setAttribute('data-df-search-suggest', q);
      b.textContent = q;
      recentChips.appendChild(b);
    });
  }

  // === KEYBOARD NAV ===
  function onKeyDown(e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
    var items = modal.querySelectorAll('[data-df-search-result]');
    if (!items.length) return;
    var active = modal.querySelector('[data-df-search-result].is-active');
    var idx = active ? Array.from(items).indexOf(active) : -1;
    if (e.key === 'ArrowDown') { e.preventDefault(); idx = Math.min(items.length - 1, idx + 1); }
    if (e.key === 'ArrowUp')   { e.preventDefault(); idx = Math.max(0, idx - 1); }
    if (e.key === 'Enter' && active) { e.preventDefault(); window.location.href = active.href; return; }
    items.forEach(function (it) { it.classList.remove('is-active'); });
    if (items[idx]) {
      items[idx].classList.add('is-active');
      items[idx].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  // === TRACKING ===
  function trackSearch(q) {
    try {
      if (window.dataLayer) window.dataLayer.push({ event: 'search', search_term: q });
      if (window.gtag) window.gtag('event', 'search', { search_term: q });
      if (window.TripleWhale && window.TripleWhale.track) window.TripleWhale.track('search', { search_term: q });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
